export default function addToCartButtonAnimationController() {
  const onAddToCartButtonClick = debounce((addToCartButton) => {
    if (typeof monster_refresh !== 'function' || addToCartButton.classList.contains('loading')) {
      return;
    }

    addToCartButton.classList.add('loading');
    addToCartButton.setAttribute('aria-disabled', true);
    addToCartButton.disabled = true;
    addToCartButton.querySelector('.loading__spinner')?.classList.remove('hidden');

    setTimeout(() => {
      addToCartButton.classList.remove('loading');
      addToCartButton.removeAttribute('disabled');
      addToCartButton.removeAttribute('aria-disabled');
      addToCartButton.querySelector('.loading__spinner')?.classList.add('hidden');
    }, 2500);
  }, 50);

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('.product-card-wrapper .quick-add__submit');

      if (button) {
        onAddToCartButtonClick(button);
      }
    },
    { capture: true }
  );
}
